import Vue from "vue";
import moment from "moment";

Vue.component("wto-datepicker", {
	props: [ "value", "locale", "datetimeFormatter","minimumDate", "maximumDate", "limitedRange" ],
	computed: {
		computedValue: {
			get () {
				if (!this.value) return this.value;
				return moment(this.value).toDate();
			},
			set (value) {
				this.$emit("update:value", this.formatDate(value));
			}
		},
		computedMinimumDate: {
			get() {
				if (!this.minimumDate) return this.minimumDate;
				return moment(this.minimumDate).toDate();
			},
			set(value) {
				this.$emit("update:minimumDate", this.formatDate(value));
			}
		},
		computedMaximumDate: {
			get() {
				if (!this.maximumDate) return this.maximumDate;
				return moment(this.maximumDate).toDate();
			},
			set(value) {
				this.$emit("update:maximumDate", this.formatDate(value));
			}
		}
	},
	methods: {
		formatDate: function (value) {
			const localDate = moment(value).local();
			return localDate.format("YYYY-MM-DD");
		}	
	},
	template: `		
	  <b-datepicker
		  v-if="limitedRange"
		  v-model="computedValue"
		  :locale="locale"
		  :min-date="computedMinimumDate"
		  :max-date="computedMaximumDate"
		  :datetime-formatter="datetimeFormatter"
          icon="calendar"
		  trap-focus
		  append-to-body>
	  </b-datepicker>
	  <b-datepicker
		  v-else
		  v-model="computedValue"
		  :locale="locale"
		  :datetime-formatter="datetimeFormatter"
          icon="calendar"
		  trap-focus
		  append-to-body>
	  </b-datepicker>
	`
});